module.exports = __webpack_public_path__ + "img/faming9.8739fce7.png";